export default "__VITE_ASSET__BLpVyint__"